import { NgModule } from '@angular/core';
import { ZuperTailwindService } from '@zuper/services/tailwind/tailwind.service';

@NgModule({
    providers: [
        ZuperTailwindService
    ]
})
export class ZuperTailwindConfigModule
{
    /**
     * Constructor
     */
    constructor(private _zuperTailwindConfigService: ZuperTailwindService)
    {
    }
}
